// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledUiToolbar = styled('div')(
  () => css`
    .ui-toolbar {
      position: fixed;
      left: 0;
      bottom: 0;
      max-height: 90px;
      background-color: #0c395a;
      border-radius: 8px 8px 0px 0px;
      width: 100%;
      height: 96px;
      z-index: 99;
      display: flex;
      align-items: center;

      .close-container {
        width: 300px;
        .icon-close {
          border: 1px solid #eeeeee;
          border-radius: 5px;
          padding: 10px;
          width: 15px;
          height: 15px;
          margin: auto 32px;
          cursor: pointer;
        }
      }

      .main-container {
        flex: 1;

        .title {
          color: white;
          font-size: 1rem;
          padding-right: 64px;
        }
      }
      .actions-container {
        padding-left: 64px;

        .action {
          margin-right: 10px;
          width: max-content;
        }
      }
    }

    @media (max-width: 1200px) {
      .ui-toolbar {
        .close-container {
          width: auto;
        }
        .main-container:not(.close-not-exists) {
          .title {
            padding-right: 16px;
          }
        }
      }
    }

    @media (max-width: 900px) {
      .ui-toolbar {
        max-height: 68px;
        height: 68px;
        .close-container {
          width: unset;
          .icon-close {
            margin: 0 16px 0 0;
          }
        }
        .main-container {
          .title {
            padding-right: 16px;
          }
        }
        .actions-container {
          padding-left: 16px;
        }
        .hide-in-mobile-size {
          display: none !important;
        }
      }
    }

    @media (max-width: 400px) {
      .ui-toolbar {
        .main-container .title {
          font-size: 0.875rem;
          padding-right: 0;
        }
        .close-container {
          .icon-close {
            margin: auto 16px;
          }
        }
        justify-content: flex-end;
      }
    }

    @media (max-width: 500px) {
      .ui-toolbar {
        .hide-500 {
          display: none;
        }
      }
    }

    @media (max-width: 330px) {
      .ui-toolbar {
        .main-container {
          .title {
            display: none;
          }
        }
      }
    }
  `
);
